<template>
  <Modal @close="closeModal">
    <template v-slot:title>{{ t("Trip_Pass", {}, { locale: $store.getters.getLang }) }}</template>
    <template v-slot:body>
      {{ t("Trip_Pass_Message", {}, { locale: $store.getters.getLang }) }}
      <div class="form-group row my-1">
        <label class="col-sm-3 col-form-label"></label>
        <div class="col-sm-9">
          <!-- <input
            type="submit"
            class="mt-3 py-2 submit_button float-end font_detail"
            value="Confirm"
            @click.prevent="tripPass"
          /> -->
          <Button
            @click.prevent="tripPass"
            class="mt-3 py-2 submit_button float-end font_detail"
            >{{ t("Confirm", {}, { locale: $store.getters.getLang }) }}</Button
          >
        </div>
      </div>
    </template>
  </Modal>
</template>

<script>
import { ref, inject } from "vue";
import store from "@/store";
import { useI18n } from "vue-i18n";
export default {
  name: "TripPassModal",
  props: {
    trip: String,
    pagination: Object
  },
  setup(props, { emit }) {
    let tripId = ref(props.trip);
    const showLoader = inject("showLoader");
    const hideLoader = inject("hideLoader");
    const { t, locale } = useI18n();
    const closeModal = () => {
      emit("update:modelValue", false);
    };
    const tripPass = () => {
      showLoader();
      store
        .dispatch("tripPass", { trip: tripId.value })
        .then(() => {
          closeModal();
          hideLoader();
        })
        .catch((error) => {
          hideLoader();
          closeModal();
          if (error.status === 401) {
            tripPass();
          }
        });
    };

    return {
      t,
      locale,
      closeModal,
      tripPass,
    };
  },
};
</script>

<style scoped></style>
